import gql from 'graphql-tag'

export const PAYMENT = gql`
  query Payment($id: ID!) {
    payment(id: $id) {
      id amount insertedAt
    }
  }
`